import StoredCardsState from '../types/StoredCardsState'

export const state: StoredCardsState = {
  cards: [],
  location: null
}
